import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'
import ProfileStore from 'store/profile/ProfileStore'

export class ProfileDeleteModalStore {
  profile: ProfileStore

  constructor(profile: ProfileStore) {
    makeAutoObservable(this)
    this.profile = profile
  }
}

export const profileDeleteModal = mx.ref<ProfileDeleteModalStore>()
